import React from 'react';
import IImage from '../../../models/viewModels/base/IImage';
import ImageComponent from '../../../components/atoms/image-component/image-component';
import styles from './comparison-carousel.module.scss';
import Carousel from '../carousel/carousel';
import CarouselComponentModel from '../../../models/components/carousel-component-model';

export type ComparisonCarouselProps = {
  image: IImage;
  carousel: CarouselComponentModel;
  id?: string;
};

export default function ComparisonCarousel({ image, carousel, id }: ComparisonCarouselProps) {
  return (
    <>
      {image && carousel?.carousel?.length > 0 && (
        <div className='comparison-carousel-container' id={id}>
          <div className={`${styles[`carousel-container`]}`}>
            <Carousel
              aspectRatio={carousel.aspectRatio}
              carouselItems={carousel.carousel}
              enableBorder={carousel.enableBorder}
              imageSize={carousel.imageSize}
            />
          </div>
          <div className={`${styles[`image-container`]}`}>
            <ImageComponent src={image.secureUrl} altText={image.alt} objectFit={`contain`} />
          </div>
        </div>
      )}
    </>
  );
}
